import { useEffect } from "react"

import { useMetrics, MetricsEvents } from "utils/use-metrics"

/**
 * Custom hook for tracking registration view metrics
 * @param registrationId - The registration ID
 * @param guideId - The guide ID
 */
export const useMetricsTracking = (
  registrationId: number | undefined,
  guideId: number | undefined
) => {
  const { trackMetricsEvent } = useMetrics()

  useEffect(() => {
    if (registrationId && guideId) {
      trackMetricsEvent(MetricsEvents.REG_VIEW, {
        registration_id: registrationId,
        guide_id: guideId,
      })
    }
  }, [registrationId, guideId, trackMetricsEvent])
}
